// Comprehensive skills list organized by categories
export const SKILLS_BY_CATEGORY = {
  'Programming Languages': [
    'JavaScript', 'Python', 'Java', 'C++', 'C#', 'Ruby', 'Go', 'Rust', 
    'PHP', 'Swift', 'Kotlin', 'TypeScript', 'Scala', 'R', 'Dart', 'Perl'
  ],
  
  'Frontend Development': [
    'React', 'Angular', 'Vue.js', 'Next.js', 'HTML', 'CSS', 'Sass', 'LESS',
    'Tailwind CSS', 'Bootstrap', 'Material-UI', 'Redux', 'Webpack', 
    'jQuery', 'Svelte', 'Nuxt.js', 'Gatsby', 'Responsive Design'
  ],
  
  'Backend Development': [
    'Node.js', 'Express.js', 'Django', 'Flask', 'Spring Boot', 'FastAPI',
    'Ruby on Rails', 'ASP.NET', 'Laravel', 'NestJS', 'GraphQL', 'REST API',
    'Microservices', 'Socket.io', 'gRPC'
  ],
  
  'Mobile Development': [
    'React Native', 'Flutter', 'iOS Development', 'Android Development', 'Xamarin', 'Ionic', 'SwiftUI', 'Jetpack Compose', 'Cordova'
  ],
  
  'Databases': [
    'MongoDB', 'MySQL', 'PostgreSQL', 'Redis', 'Oracle', 'SQL Server',
    'DynamoDB', 'Cassandra', 'Firebase', 'Elasticsearch', 'SQLite',
    'MariaDB', 'Neo4j', 'CouchDB'
  ],
  
  'Cloud & DevOps': [
    'AWS', 'Azure', 'Google Cloud', 'Docker', 'Kubernetes', 'Jenkins',
    'GitLab CI/CD', 'GitHub Actions', 'Terraform', 'Ansible', 'CI/CD',
    'Linux', 'Nginx', 'Apache', 'Heroku', 'Vercel', 'Netlify'
  ],
  
  'Data Science & AI': [
    'Machine Learning', 'Deep Learning', 'TensorFlow', 'PyTorch', 'Pandas',
    'NumPy', 'Scikit-learn', 'Natural Language Processing', 'Computer Vision',
    'Data Analysis', 'Data Visualization', 'Jupyter', 'Keras', 'OpenCV'
  ],
  
  'Design & UI/UX': [
    'Figma', 'Adobe XD', 'Sketch', 'Photoshop', 'Illustrator', 'InVision',
    'UI Design', 'UX Design', 'Wireframing', 'Prototyping', 'User Research',
    'Interaction Design', 'Visual Design', 'Design Systems'
  ],
  
  'Testing & Quality': [
    'Jest', 'Mocha', 'Cypress', 'Selenium', 'JUnit', 'TestNG', 'Pytest',
    'Unit Testing', 'Integration Testing', 'E2E Testing', 'Test Automation',
    'QA', 'Manual Testing', 'Performance Testing'
  ],
  
  'Project Management': [
    'Agile', 'Scrum', 'Kanban', 'Jira', 'Trello', 'Asana', 'Monday.com',
    'Project Planning', 'Sprint Planning', 'Backlog Management', 'Confluence'
  ],
  
  'Soft Skills': [
    'Communication', 'Leadership', 'Team Collaboration', 'Problem Solving',
    'Critical Thinking', 'Time Management', 'Presentation', 'Negotiation',
    'Conflict Resolution', 'Adaptability', 'Creativity', 'Decision Making'
  ],
  
  'Business & Marketing': [
    'SEO', 'SEM', 'Google Analytics', 'Digital Marketing', 'Content Marketing',
    'Social Media Marketing', 'Email Marketing', 'Sales', 'Business Analysis',
    'Market Research', 'Product Management', 'Growth Hacking'
  ],
  
  'Security': [
    'Cybersecurity', 'Network Security', 'Penetration Testing', 'Ethical Hacking',
    'Authentication', 'Authorization', 'OWASP', 'Security Auditing', 'Encryption'
  ],
  
  'Version Control': [
    'Git', 'GitHub', 'GitLab', 'Bitbucket', 'SVN', 'Mercurial'
  ],
  
  'Other Tools': [
    'VS Code', 'IntelliJ IDEA', 'Postman', 'Slack', 'Notion', 'Excel',
    'PowerPoint', 'Word', 'Google Workspace', 'Zoom', 'Microsoft Teams'
  ],

  'Healthcare & Medical': [
    'Patient Care', 'Clinical Research', 'Electronic Health Records', 'Medical Coding',
    'Healthcare Administration', 'Nursing', 'Pharmacy', 'Medical Billing',
    'HIPAA Compliance', 'Telemedicine', 'Laboratory Skills', 'Emergency Care',
    'Surgery', 'Radiology', 'Physical Therapy', 'Mental Health Counseling'
  ],

  'Finance & Accounting': [
    'Financial Analysis', 'Accounting', 'Bookkeeping', 'Tax Preparation',
    'Financial Planning', 'Auditing', 'Investment Banking', 'Risk Management',
    'QuickBooks', 'SAP', 'Bloomberg Terminal', 'Financial Modeling',
    'Budget Management', 'Payroll', 'Cost Accounting', 'Treasury Management',
    'Compliance', 'GAAP', 'IFRS', 'CFA', 'CPA'
  ],

  'Sales & Business Development': [
    'Sales Strategy', 'Lead Generation', 'Account Management', 'B2B Sales',
    'B2C Sales', 'Cold Calling', 'Negotiation', 'CRM Software', 'Salesforce',
    'HubSpot', 'Sales Forecasting', 'Territory Management', 'Client Relations',
    'Proposal Writing', 'Contract Negotiation', 'Pipeline Management'
  ],

  'Human Resources': [
    'Recruitment', 'Talent Acquisition', 'Employee Relations', 'HR Policies',
    'Performance Management', 'Compensation & Benefits', 'HRIS', 'Workday',
    'Onboarding', 'Training & Development', 'Labor Law', 'Diversity & Inclusion',
    'Organizational Development', 'Conflict Resolution', 'Payroll Management'
  ],

  'Operations & Supply Chain': [
    'Supply Chain Management', 'Logistics', 'Inventory Management', 'Procurement',
    'Operations Management', 'Process Improvement', 'Lean Manufacturing', 'Six Sigma',
    'Warehouse Management', 'Distribution', 'Vendor Management', 'ERP Systems',
    'Quality Control', 'Production Planning', 'Demand Forecasting'
  ],

  'Customer Service & Support': [
    'Customer Service', 'Technical Support', 'Help Desk', 'Zendesk', 'Freshdesk',
    'ServiceNow', 'Customer Success', 'Call Center Operations', 'Chat Support',
    'Email Support', 'Complaint Resolution', 'Customer Retention',
    'Client Onboarding', 'SLA Management', 'Ticketing Systems'
  ],

  'Education & Training': [
    'Teaching', 'Curriculum Development', 'Instructional Design', 'E-Learning',
    'Learning Management Systems', 'Student Assessment', 'Classroom Management',
    'Educational Technology', 'Training Delivery', 'Academic Writing',
    'Tutoring', 'Special Education', 'Adult Learning', 'Course Development'
  ],

  'Legal & Compliance': [
    'Contract Law', 'Corporate Law', 'Legal Research', 'Litigation', 'Compliance',
    'Regulatory Affairs', 'Legal Writing', 'Intellectual Property', 'Due Diligence',
    'Legal Documentation', 'Labor Law', 'Tax Law', 'Immigration Law',
    'Risk Assessment', 'Policy Development', 'Legal Tech'
  ],

  'Manufacturing & Engineering': [
    'Manufacturing Processes', 'CAD', 'AutoCAD', 'SolidWorks', 'Mechanical Engineering',
    'Electrical Engineering', 'Civil Engineering', 'Product Design', 'Prototyping',
    'Quality Assurance', 'MATLAB', 'PLC Programming', 'CNC Programming',
    'Industrial Engineering', 'Structural Analysis', 'Materials Science'
  ],

  'Real Estate & Construction': [
    'Real Estate Sales', 'Property Management', 'Real Estate Investment',
    'Construction Management', 'Project Estimation', 'Building Codes',
    'Site Supervision', 'Architecture', 'Interior Design', 'Leasing',
    'Property Valuation', 'Contract Management', 'Blueprint Reading',
    'Construction Safety', 'Urban Planning'
  ],

  'Hospitality & Tourism': [
    'Hotel Management', 'Event Planning', 'Food & Beverage Service',
    'Guest Relations', 'Front Desk Operations', 'Housekeeping Management',
    'Catering', 'Tour Operations', 'Restaurant Management', 'Hospitality Sales',
    'Customer Experience', 'Booking Systems', 'Hospitality Marketing'
  ],

  'Retail & E-commerce': [
    'Retail Management', 'Visual Merchandising', 'Inventory Control',
    'Point of Sale', 'E-commerce Platform', 'Shopify', 'WooCommerce',
    'Amazon FBA', 'Drop Shipping', 'Category Management', 'Retail Analytics',
    'Loss Prevention', 'Store Operations', 'Online Marketplace Management'
  ],

  'Media & Communications': [
    'Content Writing', 'Copywriting', 'Journalism', 'Broadcasting', 'Video Editing',
    'Adobe Premiere', 'Final Cut Pro', 'Photography', 'Videography',
    'Public Relations', 'Media Planning', 'Social Media Management',
    'Content Strategy', 'Podcasting', 'Script Writing', 'Media Relations'
  ],

  'Science & Research': [
    'Research Methodology', 'Data Collection', 'Statistical Analysis', 'SPSS',
    'Laboratory Techniques', 'Clinical Trials', 'Scientific Writing',
    'Grant Writing', 'Experiment Design', 'Quality Assurance', 'GLP', 'GMP',
    'Molecular Biology', 'Chemistry', 'Physics', 'Biotechnology'
  ],

  'Arts & Creative': [
    'Graphic Design', 'Illustration', 'Animation', 'Video Production',
    'Photography', 'Music Production', 'Sound Design', 'Art Direction',
    'Creative Direction', 'Branding', 'Typography', 'Color Theory',
    '3D Modeling', 'Game Design', 'Fashion Design', 'Industrial Design'
  ],

  'Environmental & Sustainability': [
    'Environmental Science', 'Sustainability', 'Environmental Compliance',
    'Waste Management', 'Renewable Energy', 'Energy Efficiency',
    'Carbon Footprint Analysis', 'Environmental Impact Assessment',
    'Green Building', 'LEED Certification', 'Climate Change Analysis',
    'Conservation', 'Water Management', 'Environmental Policy'
  ],

  'Agriculture & Food': [
    'Agriculture', 'Crop Management', 'Animal Husbandry', 'Food Safety',
    'Food Science', 'Food Processing', 'Agricultural Technology', 'Farming',
    'Soil Science', 'Irrigation', 'Pest Control', 'Food Quality Control',
    'Supply Chain', 'Food Service Management', 'Nutrition'
  ],

  'Transportation & Logistics': [
    'Fleet Management', 'Route Optimization', 'Transportation Planning',
    'Freight Management', 'Shipping Operations', 'Import/Export',
    'Customs Compliance', 'Last Mile Delivery', 'Warehouse Operations',
    'Transportation Safety', 'Logistics Coordination', 'Dispatch'
  ],

  'Insurance': [
    'Underwriting', 'Claims Processing', 'Risk Assessment', 'Actuarial Science',
    'Insurance Sales', 'Policy Administration', 'Loss Adjustment',
    'Insurance Law', 'Reinsurance', 'Health Insurance', 'Life Insurance',
    'Property & Casualty', 'Insurance Analytics', 'Fraud Detection'
  ],

  'Telecommunications': [
    'Network Engineering', 'Telecommunications', '5G Technology', 'VoIP',
    'Wireless Communications', 'Fiber Optics', 'RF Engineering', 
    'Telecom Infrastructure', 'Network Optimization', 'Telecom Billing', 
    'Network Monitoring', 'Satellite Communications', 'Telecom Security'
  ],

  'Energy & Utilities': [
    'Power Systems', 'Energy Management', 'Electrical Grid', 'Solar Energy',
    'Wind Energy', 'Oil & Gas', 'Power Plant Operations', 'Energy Trading',
    'Energy Efficiency', 'Utility Management', 'Renewable Energy Systems',
    'Energy Storage', 'SCADA Systems', 'Power Generation'
  ],

  'Gaming & Entertainment': [
    'Game Development', 'Unity', 'Unreal Engine', 'Game Design', 'Level Design',
    'Character Design', '3D Animation', 'Game Testing', 'Game Programming',
    'Game Art', 'VR/AR Development', 'Mobile Gaming', 'Game Analytics',
    'Esports Management', 'Entertainment Marketing'
  ]
};

// Flatten all skills into a single array and remove duplicates
export const ALL_SKILLS = [...new Set(Object.values(SKILLS_BY_CATEGORY).flat())];

// Popular skills (most commonly used across all industries)
export const POPULAR_SKILLS = [
  // Tech
  'JavaScript', 'Python', 'React', 'Node.js', 'Java', 'TypeScript',
  'AWS', 'Docker', 'Git', 'SQL', 'MongoDB', 'HTML', 'CSS',
  // Business
  'Communication', 'Leadership', 'Project Management', 'Sales',
  'Customer Service', 'Microsoft Excel', 'Data Analysis',
  // Finance & Accounting
  'Financial Analysis', 'Accounting', 'Bookkeeping',
  // Design & Marketing
  'Figma', 'UI/UX', 'Digital Marketing', 'SEO', 'Content Writing',
  // Other
  'Agile', 'Scrum', 'Problem Solving', 'Team Collaboration'
];

// Get skills by search query
export const searchSkills = (query) => {
  if (!query) return POPULAR_SKILLS;
  
  const lowerQuery = query.toLowerCase();
  return ALL_SKILLS.filter(skill => 
    skill.toLowerCase().includes(lowerQuery)
  );
};

// Get category for a skill
export const getSkillCategory = (skill) => {
  for (const [category, skills] of Object.entries(SKILLS_BY_CATEGORY)) {
    if (skills.includes(skill)) {
      return category;
    }
  }
  return 'Other';
};
